import { writable } from 'svelte/store';

import { display } from './preferences';

export const isShowedDeviceBluetoothScan = writable(false);

export const next_step = writable(
	JSON.parse(sessionStorage.getItem('next_step')) || {
		shown: false,
		next: '',
		execute: '',
		check: false,
	},
);
display.subscribe((val) => sessionStorage.setItem('next_step', JSON.stringify(val)));

export const alerts_list = writable(JSON.parse(sessionStorage.getItem('alerts_list')) || {});
alerts_list.subscribe((val) => sessionStorage.setItem('alerts_list', JSON.stringify(val)));

export const new_events = writable(false);
new_events.subscribe((val) => val);
